var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.98667 12.2333L7.05333 13.8333C7.32 14.1 7.92 14.2333 8.32 14.2333H10.8533C11.6533 14.2333 12.52 13.6333 12.72 12.8333L14.32 7.96667C14.6533 7.03333 14.0533 6.23333 13.0533 6.23333H10.3867C9.98667 6.23333 9.65333 5.9 9.72 5.43333L10.0533 3.3C10.1867 2.7 9.78667 2.03333 9.18667 1.83333C8.65333 1.63333 7.98667 1.9 7.72 2.3L4.98667 6.36667",
    strokeMiterlimit: 10,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.58667 12.2333V5.7C1.58667 4.76667 1.98667 4.43333 2.92 4.43333H3.58667C4.52 4.43333 4.92 4.76667 4.92 5.7V12.2333C4.92 13.1667 4.52 13.5 3.58667 13.5H2.92C1.98667 13.5 1.58667 13.1667 1.58667 12.2333Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/like.6465cfe21741a4dfe8af55c502cc4ab0.svg";